import React, { ReactNode } from 'react';
import styles from './StopSticker.module.scss';

interface StopStickerProps {
  children: ReactNode;
  isLargeSize?: boolean;
  className?: string;
}

const StopSticker: React.FC<StopStickerProps> = ({ children, className }) => {
  return (
    <div className={styles.stopSticker}>
      <span className={[styles.bottomRight, className].filter(Boolean).join(' ')}>
        {children}
      </span>
    </div>
  );
};

export default StopSticker;
